import { render } from "./CropSeed.vue?vue&type=template&id=d54a0762&scoped=true&ts=true"
import script from "./CropSeed.vue?vue&type=script&lang=ts"
export * from "./CropSeed.vue?vue&type=script&lang=ts"

import "./CropSeed.vue?vue&type=style&index=0&id=d54a0762&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d54a0762"]])

export default __exports__